import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'kbModuleLink',
})
export class KbModuleLinkPipe implements PipeTransform {
  private readonly sanitizer: DomSanitizer = inject(DomSanitizer);

  public transform(
    value: string | undefined | null,
  ): SafeHtml | null | undefined {
    if (typeof value === 'string') {
      const regexp: RegExp =
        /(\[module\])([\S\s]+?)(\[link\])([\S\s]+?)(\[\/link\])([\S\s]+?)(\[\/module\])/g;
      const parsed: string = value.replace(
        regexp,
        (_match, _g1, g2, _g3, g4) =>
          `<div class="kb-module-link">>>> <a href="${g4}">${g2}</a></div>`,
      );

      return this.sanitizer.bypassSecurityTrustHtml(parsed);
    }

    return value;
  }
}
